import React, { Component } from "react";
import { FormGroup, Label, Input } from 'reactstrap';
export default class CommentMetadataForm extends Component {

    constructor(props) {
        super(props);
        this.parentMetadata = this.props.parentMetadata;
        this.strings = this.props.strings;
    }

    render() {
        return (
            <div>
                <div>Comment Metadata Form</div>
                <FormGroup key="1">
                    <Label>{this.props.strings['Documenttype']}</Label>
                    <Input type="text"
                        id="dokumenttyp"
                        name="Dokumenttyp"
                        value="Comment"
                        readOnly={true}
                    />
                </FormGroup>
                <FormGroup key="2">
                    <Label>{"Skapad av"}</Label>
                    <Input type="text"
                        id={"skapadav"}
                        name={"Skapad av"}
                        value={this.parentMetadata.Creator.value}
                        readOnly={true}
                    />
                </FormGroup>
                <FormGroup key="3">
                    <Label>{"Skapad datum"}</Label>
                    <Input type="text"
                        id={"skapaddatum"}
                        name={"Skapad datum"}
                        value={this.parentMetadata["Created at"].value}
                        readOnly={true}
                    />
                </FormGroup>
                <FormGroup key="4">
                    <Label>{"Huvuddokument"}</Label>
                    <Input type="text"
                        id={"huvuddokument"}
                        name={"Huvuddokument"}
                        value={this.parentMetadata.Title?.value ?? this.parentMetadata.Name?.value ?? this.parentMetadata["File name"].value}
                        readOnly={true}
                    />
                </FormGroup>
                <FormGroup key="5">
                    <Label>{"Underdokument"}</Label>
                    <Input type="text"
                        id={"underdokument"}
                        name={"Underdokument"}
                        value={""}
                        readOnly={true}
                    />
                </FormGroup>
            </div>
        );
    }
}